import { Routes } from '@angular/router';
import { clientRoutes } from './client/client.routes';
import { freelancerRoutes } from './freelancer/freelancer.routes';
import { userGuard } from 'app/core/guards/user.guard';

export const userRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/components/guest-home/guest-home.component').then((m) => m.GuestHomeComponent),
  },
  {
    path: 'chats',
    loadComponent: () =>
      import('./../user/user-chat/user-chat.component').then((m) => m.UserChatComponent),
    canActivate: [userGuard],
  },
  {
    path: 'guide-tips',
    loadComponent: () =>
      import('./home/components/guide-tips-list/guide-tips-list.component').then(
        (m) => m.GuideTipsListComponent
      ),
  },
  {
    path: 'guide-tips/:id',
    loadComponent: () =>
      import('./home/components/guide-tips-details/guide-tips-details.component').then(
        (m) => m.GuideTipsDetailsComponent
      ),
  },
  {
    path: '',
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileRoutingModule),
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./gigs/components/gigs-filter/gigs-filter.component').then(
        (m) => m.GigsFilterComponent
      ),
  },
  {
    path: 'service/:id',
    loadComponent: () =>
      import('./gigs/components/gigs-details/gigs-details.component').then(
        (m) => m.GigsDetailsComponent
      ),
  },
  {
    path: 'projects',
    loadComponent: () =>
      import('../../components/freelancer-layout/home/components/freelancer-home/freelancer-home.component').then(
        (m) => m.FreelancerHomeComponent
      ),
  },
  {
    path: 'project/:id',
    loadComponent: () =>
      import('./profile/components/profile-main-structure/profile-content/profile-content-tabs/portfolio/show-portfolio/show-portfolio.component').then(
        (m) => m.ShowPortfolioComponent
      ),
  },
  {
    path: 'orders',
    loadComponent: () =>
      import('../user/requests/components/service-request-list/service-request-list.component').then(
        (m) => m.ServiceRequestListComponent
      ),
  },
  {
    path: 'service/request/:id',
    loadComponent: () =>
      import('../user/requests/components/service-details-view/service-details-view.component').then(
        (m) => m.ServiceDetailsViewComponent
      ),
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  {
    path: 'freelancers-list',
    loadComponent: () =>
      import('../user/freelancer/components/freelancer-list/freelancer-list.component').then(
        (m) => m.FreelancerListComponent
      ),
  },
  {
    path: 'client',
    children: clientRoutes,
  },
  {
    path: 'freelancer',
    children: freelancerRoutes,
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then((m) => m.AboutUsComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent
      ),
  },
  {
    path: 'faq',
    loadComponent: () => import('./faq/faq.component').then((m) => m.FaqComponent),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'timeline',
    loadComponent: () => import('./timeline/timeline.component').then((m) => m.TimelineComponent),
  },
];
